import React, { useEffect, useState } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import Text from "../../../../shared/components/Text";
import { UserDetailsWithKycProviderDataMapper } from "../../../../../utils/mappers/MainUserDetails/MainUserDetailsMapper";
import { documentTypes } from "../../../kyc/shared/config";
import { useActionCallback } from "../../../../../utils/hooks/useActionCallback";
import { FLOW_MESSAGES } from "../../../../shared/components/flowMessages/components";
import { removeNullKeysFromObject } from "../../../kyc/KycAutomatic/shared/constants/removeNullKeysFromObjects";

export const useVideoId = () => {
  const {
    state: { loan, participant, borrowerDocumentationFile },
    dispatch,
  } = React.useContext(ProcessContext);

  const [electronicIdSubmitted, setElectronicIdSubmitted] = useState(false);

  useEffect(() => {
    if (
      participant &&
      participant.onboardingDetails?.user_details?.document_id
        ?.document_type === "nie_eu"
    ) {
      dispatch({
        type: "REQUEST_GET_BORROWER_DOCUMENTATION_FILE_BY_LOAN_ID_BORROWER_ID_AND_FILE_TYPE",
        payload: {
          loanId: loan.id,
          borrowerId: participant.participantId,
          fileType: "passport",
        },
      });
    }
  }, [participant]);

  const dispatchModuleOkRequests = () => {
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: { videoIdProcessPassed: true },
    });
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.SEND_OK.id, fadeIn: false },
    });
  };

  const onSubmitKycElectronicId = (electronicIdValues) => {
    setElectronicIdSubmitted(true);
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: true,
        loadingMessage: <Text tId="PLEASE_WAIT" />,
      },
    });
    const selectedDocumentType = documentTypes.find(
      (document) =>
        document.display === electronicIdValues?.selectedDocumentType
    )?.id;

    const requestData = {
      ...electronicIdValues,
      loan,
      documentType: selectedDocumentType,
    };

    let dehydratedData =
      UserDetailsWithKycProviderDataMapper.reverseMapByLoanValues(
        requestData,
        participant,
        borrowerDocumentationFile
      );

    dispatch({
      type: "REQUEST_PATCH_SET_USER_DETAILS_WITH_KYC_PROVIDER_DATA",
      payload: dehydratedData,
    });
  };

  useActionCallback(
    "REQUEST_PATCH_SET_USER_DETAILS_WITH_KYC_PROVIDER_DATA_FULFILLED",
    () => {
      const participantProfessionalDetails = participant.onboardingDetails
        ?.user_details.professional_details
        ? removeNullKeysFromObject(
            participant.onboardingDetails?.user_details.professional_details
          )
        : null;

      if (participantProfessionalDetails) {
        dispatch({
          type: "REQUEST_PATCH_SET_PROFESSIONAL_DETAILS_AND_SEQUENCE",
          payload: {
            op: "processPatchSetProfessionalDetails",
            id: participant.participantId,
            loan_id: loan.id,
            professional_details: participantProfessionalDetails,
          },
        });
      }

      if (!participantProfessionalDetails) {
        dispatchModuleOkRequests();
      }
    }
  );

  useActionCallback(
    "REQUEST_PATCH_SET_PROFESSIONAL_DETAILS_AND_SEQUENCE_FULFILLED",
    () => {
      dispatchModuleOkRequests();
    }
  );

  useActionCallback(
    "REQUEST_PATCH_SET_USER_DETAILS_WITH_KYC_PROVIDER_DATA_REJECTED",
    () => {
      dispatch({
        type: "UPDATE_PROCESS_CONTEXT",
        payload: { videoIdProcessPassed: false },
      });

      dispatch({
        type: "SET_FLOW_ITEM_OK",
      });
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
    }
  );
  return {
    electronicIdSubmitted,
    onSubmitKycElectronicId,
  };
};
